import Card from "./Card";
import React, { useEffect, useState } from "react";
import SignChart from "./SignChart";
import ProgressChart from "./ProgressChart";
import WelnessChart from "./WelnessChart";
import ChartCard from "./ChartCard";
import ActivityChart from "./ActivityChart";
import VisitorChart from "./VisitorChart";
import EmojiChart from "./EmojiChart";
import appconstant from "../../../themes/appconstant";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  dashboardLoad,
  getWhoScoreLoad,
  signupsLoad,
  topUsageLoad,
  upcomingAssessmentLoad,
  wellnessChartLoad,
} from "../../../redux/slices/dash.slice";
import { Select } from "antd";
import { departmentsListLoad } from "../../../redux/slices/department.slice";
import { capitalizeFirstLetters } from "../../../utils/global-func";
const Dashboard = ({ myid }) => {
  const dispatch = useDispatch();
  const [department, setDepartment] = useState(null);
  const { departmentListData, departmentsListPaginationData } = useSelector(
    (state) => state?.departmentsReducer
  );
  let departMentOptions =
    departmentListData?.map((item) => ({
      label: capitalizeFirstLetters(item.name),
      value: item._id,
    })) || [];
  departMentOptions =
    departMentOptions?.length > 0
      ? [{ label: "All", value: null }, ...departMentOptions]
      : [{ label: "All", value: null }];
  let LIST_LIMIT = 1000;

  useEffect(() => {
    const data = {
      offset: 0,
      limit: LIST_LIMIT,
      search: "",
      orgId: myid,
    };
    dispatch(departmentsListLoad(data));
  }, []);

  useEffect(() => {
    const data = {
      organisation: myid,
      department,
    };
    dispatch(signupsLoad(data));
    dispatch(dashboardLoad(data));
    dispatch(topUsageLoad(data));
    dispatch(wellnessChartLoad(data));
  }, [dispatch, department]);

  const { whoScoreSuccess } = useSelector((state) => state.dashboardReducer);

  useEffect(() => {
    const currentDate = moment();
    const weeksData = {};

    for (let i = 0; i < 4; i++) {
      const startOfWeek = currentDate
        .clone()
        .subtract(i, "weeks")
        .startOf("isoWeek");
      const endOfWeek = currentDate
        .clone()
        .subtract(i, "weeks")
        .endOf("isoWeek");

      weeksData[`week${i + 1}`] = {
        startDate: startOfWeek.format("YYYY-MM-DD"),
        endDate: endOfWeek.format("YYYY-MM-DD"),
      };
    }
    if (whoScoreSuccess) {
      dispatch(
        getWhoScoreLoad({
          dateObject: weeksData,
          organisation: myid,
          department,
        })
      );
    }
  }, [dispatch, whoScoreSuccess, department]);

  useEffect(() => {
    const currentDate = moment();
    const weeksData = {};

    for (let i = 0; i < 4; i++) {
      const startOfWeek = currentDate
        .clone()
        .subtract(i, "weeks")
        .startOf("isoWeek");
      const endOfWeek = currentDate
        .clone()
        .subtract(i, "weeks")
        .endOf("isoWeek");

      weeksData[`week${i + 1}`] = {
        startDate: startOfWeek.format("YYYY-MM-DD"),
        endDate: endOfWeek.format("YYYY-MM-DD"),
        startTimestamp: startOfWeek.valueOf(), // Timestamp for the start of the week
        endTimestamp: endOfWeek.valueOf(), // Timestamp for the end of the week
      };
    }

    dispatch(
      getWhoScoreLoad({ dateObject: weeksData, organisation: myid, department })
    );
  }, [dispatch, department]);

  useEffect(() => {
    dispatch(upcomingAssessmentLoad({ organisation: myid, department }));
  }, [dispatch, department]);

  const dashboardData = useSelector((state) => state.dashboardReducer);
  const moodsLogged = dashboardData.moodsLogged
    ? dashboardData.moodsLogged.toFixed(0)
    : "0";
  const thoughtsLogged = dashboardData.thoughtsLogged
    ? dashboardData.thoughtsLogged.toFixed(0)
    : "0";
  return (
    <>
      <div className="w-full">
        <div className="special-drop w-40 ml-5 mb-5">
          <div className=" mb-2">Department</div>
          <Select
            onChange={(val) => setDepartment(val)}
            value={department}
            placeholder={"Department"}
            options={departMentOptions}
          />
        </div>
        <div className="summery-width mx-auto pt-1">
          <div className=" flex justify-between gap-3 f md:justify-center lg:flex-wrap">
            <Card text={appconstant.signups} data={dashboardData.signUps} />
            <Card
              text={appconstant.comunityposts}
              data={dashboardData.communityPost}
            />
            <Card
              text={appconstant.moodlogged}
              data={`${moodsLogged}%` || "NA"}
            />
            <Card
              text={appconstant.thoughtslogged}
              data={`${thoughtsLogged}%` || "NA"}
            />
          </div>

          <div className="flex gap-6 mt-6 lg:flex-col">
            <div className="  flex flex-col gap-6 w-[67%] lg:w-[100%]">
              <EmojiChart orgId={myid} department={department} />
              {/* VERSION 1 */}
              {/* <DirectCareChart /> */}
              <VisitorChart orgId={myid} department={department} />
            </div>

            <div className="flex flex-col gap-6 w-[33%]  lg:items-center lg:w-[500px] ">
              <ChartCard title="Top Usage">
                <ProgressChart />
              </ChartCard>

              <ChartCard
                title="Signups"
                subtitle={appconstant.basedOnTheGender}
              >
                <SignChart />
              </ChartCard>

              <ChartCard title="WHO-5 Wellness Index">
                <WelnessChart />
              </ChartCard>
            </div>
          </div>

          <div className="mt-6 pb-6">
            <ActivityChart myid={myid} department={department} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
